type CNPJData = {
  completo: string | null;
  raiz?: number;
  filial?: number;
};

const DEFAULT_VALUE = "CNPJ não encontrado";

export default class CNPJ {
  completo: string | null;
  raiz?: number;
  filial?: number;

  private constructor(props: CNPJData) {
    this.completo = props.completo;
    this.raiz = props.raiz;
    this.filial = props.filial;

    Object.freeze(this);
  }

  static create(cnpjData: CNPJData): CNPJ {
    return new CNPJ(cnpjData);
  }

  static getDefaultCNPJErrorMessage(): string {
    return DEFAULT_VALUE;
  }

  getValue(): CNPJData {
    return this;
  }

  unmask(): string {
    return this.completo?.replace(/[^\d]+/g, "") || DEFAULT_VALUE;
  }

  mask(): string {
    return (
      this.completo?.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      ) || DEFAULT_VALUE
    );
  }
}
